import React from 'react';
import { Stack, StackProps } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';

const statusToColor = {
  'warning': 'brand pink',
  '': 'gray dark',
};
const statusToVariant = {
  'warning': 'body bold',
  '': 'caption',
};

export interface SubscriptionStatusProps extends StackProps {
  icon?: React.ReactNode;
  status?: 'warning';
}
export const SubscriptionStatus: React.FC<SubscriptionStatusProps> = ({ icon, children, status = '', ...props }) => {
  return (
    <Stack alignItems="center" direction="row" gap={1} {...props}>
      {icon}
      <Typography sx={{ color: statusToColor[status] }} variant={statusToVariant[status]}>
        {children}
      </Typography>
    </Stack>
  );
};
SubscriptionStatus.displayName = 'SubscriptionStatus';
